import React, { useEffect, useState } from "react";

import { actions } from "../actions";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import logo from "../assets/QuallyHireGreen.png";
import mainSlider from "../assets/mainSlider.jpg";
import resume from "../assets/resume.png";
import { Button, Empty } from "antd";
import Footer from "../landing/footer";
import Features from "../landing/features";
import ForWho from "../landing/forWho";
import LandingHeader from "./header";

import { DownOutlined } from "@ant-design/icons";
import { Dropdown, Space } from "antd";

import "./landing.css";
import "../styles/global.css";

function Landing (props)  {
  const [loader, SetLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [error,setError] = useState("")
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { handleSubmit } = props;


  useEffect(() => {
    localStorage.removeItem("userDetails");
  }, []);

  const onSubmit = () => {
    let dataToSend = { email: email };
    let inputData = { email: email };
    SetLoader(true);

    dispatch(actions.SignIn(dataToSend, (error, status) => {
      if (!error) {
        navigate("/otp", { state: { inputData, type: "login" } });
        SetLoader(false);
      } else {
        // Handle the error case
        SetLoader(false);
        console.error("API Error:", error);
        let e = error.split("or")
        setError(e[0] + "signup first")
       // setErrorMessage(error); // Set the error message in state
      }
    }));
  };


  const handleSignup = () => {
    navigate('/signup/qhrflow')
  };

  const handleJobSeekers = () => {
    navigate('/nujobs')
  };
  const handleEmployers = () => {
    navigate('/nujobsemployerpage')
  };
  
  const handleResumeAnalysisFree = () => {
    navigate('/resumeAnalysisFree')
  };

  const handleCareerListing = () => {
    navigate('/careerWebsites')
  };

  const handleContact = () =>{
    navigate('/qhrflowcontact')
  }
  return (
    <div className="landing-wrapper">
      <div className="landing-header">
          <LandingHeader/>
       </div>

      <div className="landing-main-slider">
          <div className="punch-heading-wrapper">
              <div className="punch-heading">              
                
                <span className="gradient-text gradient-blue-purple">
                  ✦ All-in-One AI Hiring Platform
                </span>                  
              </div>

              <div className="punch-sub-heading">
                Automate hiring, publish jobs, and scale recruitment — faster and smarter.
              </div>


              <div style={{ display: "flex", gap: "16px", marginLeft: "`100px",marginTop: "20px" ,justifyContent:"Center"}}>
                <Button type="primary" size="large" shape="round" 
                        onClick = {handleContact}
                        className="hero-primary-button">
                  Book Demo
                </Button>

                <Button size="large" shape="round" onClick={handleSignup} className="hero-secondary-button">
                  Sign up Now
                </Button>
              </div>              
          </div>
          <div className="punch-heading-wrapper">
              <div className="punch-heading">                              
                <span className="gradient-text gradient-blue-purple">
                  NuJobs Search Platform 
                </span>                  
              </div>

              <div className="punch-sub-heading">
                For Jobseekers, Employers. Search Jobs faster.
              </div>


              <div style={{ display: "flex", gap: "16px", marginLeft: "`100px",marginTop: "20px" ,justifyContent:"Center"}}>
                <Button size="large" shape="round" onClick={handleJobSeekers}className="hero-secondary-button">
                   Search Jobs
                </Button>
                <Button size="large" shape="round" onClick={handleEmployers}className="hero-secondary-button">
                   Post Jobs
                </Button>                
              </div>              
          </div>
       </div>       
       <div className="landing-forWho">
          <ForWho/>
       </div>       
       <div className="landing-features">
          <Features/>
       </div>        
       <div className="landing-footer">
          <Footer/>
       </div>       
     </div>
  );
};

export default Landing;
